import isExperienceEditor from '@utils/is-experience-editor';

(function() {
    if ($('[data-slider="articleCardMobile"]').length <= 0) {
        return;
    }

    var articleCardSliderMobile = function() {
        var ui = {};

        function cacheUI() {
            ui.$body = $('body');
            ui.$articleCardM = $('[data-slider="articleCardMobile"]');
        }

        function initarticleCardSliderMobile(e) {
            ui.$articleCardM.each(function(index, element) {
                let newSlidesToShow = 2.75;
                if (element.hasAttribute('data-slidesToShow')) {
                    newSlidesToShow = parseInt(
                        $(element).attr('data-slidesToShow')
                    );
                }

                let showDots = false;
                if (element.hasAttribute('data-showDots')) {
                    if (element.dataset.showdots == 'true') {
                        showDots = true;
                    }
                }

                let infiniteScroll = false;
                if (element.hasAttribute('data-infiniteScroll')) {
                    if (element.dataset.infinitescroll == 'true') {
                        infiniteScroll = true;
                    }
                }

                $(this).addClass('js-articleCardM-slider' + index);
                var item_length = $(
                    '.js-articleCardM-slider' + index + ' > div'
                ).length;
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-articleCardM-slider' + index).slick({
                        autoplay: false,
                        infinite: infiniteScroll,
                        arrows: true,
                        dots: false,
                        slidesToShow: newSlidesToShow,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        rows: 0, // Fix vor v1.8.0-1
                        responsive: [
                            {
                                breakpoint: 5000,
                                settings: 'unslick', //Note: Clears out all event handlers
                            },
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToShow: newSlidesToShow,
                                    slidesToScroll: 1,
                                    arrows: false,
                                    dots: showDots,
                                },
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1.3,
                                    slidesToScroll: 1,
                                    arrows: false,
                                    dots: showDots,
                                },
                            },
                        ],
                    });
                }
            });

            ui.$articleCardM.addClass('initialize');
        }

        function initarticleCardSliderAllScreens(e) {
            ui.$articleCardM.each(function(index, element) {
                let newSlidesToShow = 2.75;
                if (element.hasAttribute('data-slidesToShow')) {
                    newSlidesToShow = parseInt(
                        $(element).attr('data-slidesToShow')
                    );
                }

                let showDots = false;
                if (element.hasAttribute('data-showDots')) {
                    if (element.dataset.showdots == 'true') {
                        showDots = true;
                    }
                }

                let infiniteScroll = false;
                if (element.hasAttribute('data-infiniteScroll')) {
                    if (element.dataset.infinitescroll == 'true') {
                        infiniteScroll = true;
                    }
                }

                $(this).addClass('js-articleCardM-slider' + index);
                var item_length = $(
                    '.js-articleCardM-slider' + index + ' > div'
                ).length;
                if (item_length > 1 && !isExperienceEditor) {
                    $('.js-articleCardM-slider' + index).slick({
                        autoplay: false,
                        infinite: infiniteScroll,
                        arrows: true,
                        dots: false,
                        slidesToShow: newSlidesToShow,
                        slidesToScroll: 1,
                        adaptiveHeight: false,
                        rows: 0, // Fix vor v1.8.0-1
                        responsive: [
                            {
                                breakpoint: 991,
                                settings: {
                                    slidesToScroll: 1,
                                    slidesToShow: newSlidesToShow,
                                    arrows: false,
                                    dots: showDots,
                                },
                            },
                            {
                                breakpoint: 767,
                                settings: {
                                    slidesToShow: 1.3,
                                    slidesToScroll: 1,
                                    arrows: false,
                                    dots: showDots,
                                },
                            },
                        ],
                    });
                }
            });

            ui.$articleCardM.addClass('initialize');
        }

        function init() {
            cacheUI();
            if (
                $('[data-slider="articleCardMobile"][desktop-slider="true"]')
                    .length <= 0
            ) {
                initarticleCardSliderMobile();
            } else {
                initarticleCardSliderAllScreens();
            }
        }

        return {
            init: init,
        };
    };

    var articleCardSliderMobile = articleCardSliderMobile();
    articleCardSliderMobile.init();
})(window);
